import { Controller } from "@hotwired/stimulus"

// Propagates the first filled value to other empty fields of the same type
// (weight or reps) within the same exercise card.
export default class extends Controller {
  propagate(event) {
    const input = event.target
    const value = input.value.trim()
    if (!value) return

    const fieldType = input.dataset.fieldType
    if (!fieldType) return

    const allInputs = this.element.querySelectorAll(`[data-field-type="${fieldType}"]`)
    allInputs.forEach(other => {
      if (other !== input && !other.value.trim() && !other.disabled) {
        other.value = value
      }
    })
  }
}
